/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 12L6 12M18 12L15.5 9.5M18 12L15.5 14.5M6 12L8.5 9.5M6 12L8.5 14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 21V3M22 3V21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M2 21V3M22 3V21M18 12H6M18 12L15.5 9.5M18 12L15.5 14.5M6 12L8.5 9.5M6 12L8.5 14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M2 21V3M22 3V21M18 12H6M18 12L15.5 9.5M18 12L15.5 14.5M6 12L8.5 9.5M6 12L8.5 14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 6L2 3M2 21L2 10M22 18V21M22 3V14M18 12H6M18 12L15.5 9.5M18 12L15.5 14.5M6 12L8.5 9.5M6 12L8.5 14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 21V3M22 3V21M18 12H6M18 12L15.5 9.5M18 12L15.5 14.5M6 12L8.5 9.5M6 12L8.5 14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M2 21V3M22 3V21M18 12H6M18 12L15.5 9.5M18 12L15.5 14.5M6 12L8.5 9.5M6 12L8.5 14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
